/*
 * @Description:
 * @LastEditors: wjx
 * @Date: 2020-11-10 13:57:25
 */
import person from './person';
import merchant from './merchant';

export default [
  { name: '自然人', childMenu: [person] },
  { name: '个体', childMenu: [merchant] }
];
